export const environment: any = {
  "hostname": 'localhost',
  "production": false,
  "baseLoginUrl": "https://login.microsoftonline.com/9107b728-2166-4e5d-8d13-d1ffdf0351ef/oauth2/v2.0/authorize?client_id=e4fce455-9929-448f-ab92-833726845037&response_type=code&redirect_uri=http://localhost:4200&response_mode=query&scope=openid&state=23343&code_challenge=",
  "tokenURL": "https://login.microsoftonline.com/9107b728-2166-4e5d-8d13-d1ffdf0351ef/oauth2/v2.0/token",
  "logoutUrl": "https://login.microsoftonline.com/common/oauth2/logout",
  "grantType": "authorization_code",
  "clientId": "e4fce455-9929-448f-ab92-833726845037",
  "redirectURI": "http://localhost:4200",
  "region": "us-west-2",
  "turnOverReport": "https://w552nhe1rf.execute-api.us-west-2.amazonaws.com/dev/",
  "aseReport": "https://fa2qaudy26.execute-api.us-west-2.amazonaws.com/dev/",
  "jobEnrollment": "https://20ee7ohtv2.execute-api.us-west-2.amazonaws.com/dev/",
  "dealerTrainingBilling": "https://p6okaqkai4.execute-api.us-west-2.amazonaws.com/dev/",
  "elevateBilling": "https://zna4gbgfw7.execute-api.us-west-2.amazonaws.com/dev/",
  "eventBilling": "https://w438svrm09.execute-api.us-west-2.amazonaws.com/dev/",
  "staffMaster": "https://ukoifaz6de.execute-api.us-west-2.amazonaws.com/dev/",
  "UserAccess": "https://nd5o2ob147.execute-api.us-west-2.amazonaws.com/dev/",
  "tenure": "https://411cr35aug.execute-api.us-west-2.amazonaws.com/dev/",
  "chatbot": "https://w552nhe1rf.execute-api.us-west-2.amazonaws.com/dev/",
  "eventDashboard": "https://i9hytjtat5.execute-api.us-west-2.amazonaws.com/dev/",
  "eliteCertification": "https://hbruevfe48.execute-api.us-west-2.amazonaws.com/dev/",
  "impactAnalysis":"https://jo0ryojvq3.execute-api.us-west-2.amazonaws.com/dev/",
  "googleAnalytics":"https://uhgh3nes2m.execute-api.us-west-2.amazonaws.com/dev/",
  "dealerScorecard":"https://jn7r7nqslg.execute-api.us-west-2.amazonaws.com/dev/"
};

export const applyConfig = (config: any) => {
  Object.assign(environment, config);
};

